import React, { Fragment } from 'react';
const Loader = (props) => {
  return (
    <Fragment>
      <div className={`loader-wrapper`}>
        <svg version="1.0" className="loader-image" xmlns="http://www.w3.org/2000/svg"
        width="1024.000000pt" height="1024.000000pt" viewBox="0 0 1024.000000 1024.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)" stroke="none">
        <path fill="#1c5e30" d="M6406 9505 c-320 -52 -602 -190 -829 -405 -489 -463 -624 -1188 -332
        -1795 323 -674 1086 -1018 1806 -816 269 76 487 208 690 419 208 215 338 462
        405 772 15 67 19 128 19 295 0 183 -3 223 -23 313 -34 151 -66 242 -133 377
        -210 425 -600 726 -1071 826 -126 27 -407 34 -532 14z"/>
        <path fill="#8c1030" d="M2590 8165 c-474 -72 -905 -308 -1212 -663 -267 -310 -431 -682 -479
        -1086 -19 -161 -6 -463 26 -616 81 -386 250 -708 520 -988 365 -380 830 -588
        1360 -609 906 -35 1728 566 1979 1447 200 704 -8 1469 -540 1980 -288 277
        -627 449 -1039 527 -115 22 -490 26 -615 8z m485 -984 c162 -33 301 -100 437
        -210 328 -265 454 -733 304 -1132 -92 -246 -295 -462 -533 -570 -561 -254
        -1224 66 -1385 666 -137 515 162 1060 671 1219 113 36 166 43 301 45 77 0 145
        -5 205 -18z"/>
        <path fill="#a07d2c" d="M6627 5830 c-1208 -93 -2179 -1002 -2352 -2202 -34 -233 -29 -542 11
        -777 138 -814 661 -1514 1399 -1876 315 -154 600 -231 958 -257 330 -24 718
        31 1033 147 160 59 389 176 534 273 387 258 685 597 885 1007 92 188 136 308
        185 499 61 242 74 355 74 631 0 270 -12 373 -70 613 -248 1020 -1114 1793
        -2154 1926 -152 19 -369 26 -503 16z m496 -999 c146 -32 268 -76 407 -147 776
        -398 1083 -1356 684 -2134 -79 -155 -161 -267 -294 -401 -327 -328 -757 -488
        -1228 -457 -723 47 -1315 584 -1449 1313 -26 141 -24 418 5 563 134 671 646
        1168 1318 1277 130 21 427 13 557 -14z"/>
        </g>
        </svg>

      </div>
    </Fragment>
  );
};

export default Loader;
